<template>
  <div id="" class="router-page" pageName="">
    <div style="margin-bottom: 1.5rem;">
      <el-button type="primary" @click="addVideo">添加视频</el-button>
    </div>
    <div v-for="(item, i) in videoList" :key="`vidoe-${i}`">
      <div>
        <el-form ref="form" :model="item" label-width="5rem">
          <el-form-item label="曲速" required>
            <el-input-number v-model="item.speed" style="width: 10rem !important;"></el-input-number>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <input type="file" id="fileUpload" @change="fileChange($event, item)" />
        <p class="progress">仅支持MP4视频文件(上传停止可再次点击按钮续传)</p>
      </div>
      <div class="progress">
        <span>上传进度: <i id="auth-progress">{{ item.progress }}</i> %</span>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 内容管理 - 新增/编辑视频
 */
export default {
  name: "AddVideos",
  props: {
    courseInfo: { type: Object, default: () => {} }, // 父课程的相关信息
  },
  data() {
    return {
      videoList: [], // 存放视频列表
      videoInfo: {
        speed: "", // 速度
        file: "", // 视频文件
        contentId: "", // 当前视频对应的课程id，上传视频前调用 content/add.json 生成
        authRes: "", // 上传完成后的完整回调凭证
        videoId: "", // 上传后返回的视频id
        progress: 0, // 当前视频的上传进度
        uploader: "", // 视频上传实例
        uploadStatus: -1, // 上传状态 -1-未初始化  0-等待中  1-上传中  2-上传结束  3-上传失败
        startUpload: false, // 开始上传后，禁止所有操作
      },
    };
  },
  created() {
    // 如需实现在一个页面同时上传多个文件，可通过创建多个上传实例来实现。一个上传实例对应一个上传文件，一个上传实例不能同时上传多个文件。
  },
  methods: {
    // 添加视频
    addVideo() {
      this.videoList.push(Object.assign({}, this.videoInfo));
    },

    /**
     * 视频文件变换时触发  添加移除都会触发
     * @param {File} file 选择的视频文件
     * @param {Object} info 视频对应的videoList中的对象
     */
    fileChange(file, info) {
      console.log("视频信息", info);
      // this.startUploadFlag = true; // 文件变换时 上传按钮禁用  类型正确再打开
      // this.playFlag = false; // 关闭播放容器
      // this.videoFlag = false; // 关闭视频容器
      // this.usePlay = false; //  关闭计数
      // this.playBtnDisable = true; // 按钮不可点击
      info.file = file.target.files[0]; // 获取选择的文件
      if (!info.file) {
        return this.$message.error("请先选择需要上传的文件!");
      }
      let userData = '{"Vod":{}}'; // 上传列表
      // 检查该组实例是否存在
      if (info.uploader) { // 停止上传toLowerCase
        info.uploader.stopUpload();
        info.progress = 0; // 进度置零
      }
      // 创建上传实例
      info.uploader = this.getUpload(info);
      // 添加文件
      info.uploader.addFile(info.file, null, null, null, userData);
    },
    // 创建上传实例
    getUpload(info) {
      let that = this;
      let uploader = new AliyunUpload.Vod({
        // 阿里账号ID，必须有值 ，值的来源https://help.aliyun.com/knowledge_detail/37196.html
        userId: "1689030746142927",
        region: "cn-shanghai",
        partSize: 1048576, // 分片大小默认1M，不能小于100K
        parallel: 5, // 并行上传分片个数，默认5
        retryCount: 3, // 网络原因失败时，重新上传次数，默认为3
        retryDuration: 2, // 网络原因失败时，重新上传间隔时间，默认为2秒
        enableUploadProgress: true, // 是否上报上传日志到点播，默认为true
        // 添加文件成功
        addFileSuccess: function (uploadInfo) {
          console.log("视频添加成功: " + uploadInfo.file.type);
          if (uploadInfo.file.type === "video/mp4") {
            info.uploadStatus = 0; // 该组实例转为待上传
          } else {
            return that.$message.error("仅支持MP4视频文件");
          }
        },
        // 开始上传
        onUploadstarted: function (uploadInfo) {
          console.log("开始上传: " + uploadInfo.file.name);
          info.uploadStatus = 1; // 上传中
          let fileExt = uploadInfo.file.name.split(".");
          fileExt = fileExt[fileExt.length - 1];
          if (uploadInfo.videoId) {
            console.log("断点续传------------------------------");
            // 如果 uploadInfo.videoId 存在, 调用 刷新视频上传凭证接口  GET /1.0/content/upload/video/auth/refresh.json
            that.$api.get("/content/upload/video/auth/refresh.json", { videoId: uploadInfo.videoId }).then((success) => {
              info.authRes = success.data; // 保存上传返回的凭证
              info.videoId = success.data.videoId; // 视频id
              // 设置凭证
              // 从点播服务获取的uploadAuth、uploadAddress和videoId,设置到SDK里
              let uploadAuth = success.data.uploadAuth; // 上传凭证
              // let videoId = success.data.videoId;
              let uploadAddress = success.data.uploadAddress;
              uploader.setUploadAuthAndAddress(
                uploadInfo,
                uploadAuth,
                uploadAddress
              );
            }, (error) => {
              // 刷新不到凭证就重新获取
              let params = { // 在文件变动的时候这些字段有值
                cid: that.courseInfo.cid,
                title: that.courseInfo.title,
                fileExt: fileExt,
              };
              that.$api.get("/content/upload/video/auth.json", params).then((success) => {
                // 保存结果
                info.authRes = success.data;
                info.videoId = success.data.videoId; // 视频id
                // 设置凭证 从点播服务获取的uploadAuth、uploadAddress和videoId,设置到SDK里
                let uploadAuth = success.data.uploadAuth;
                let videoId = success.data.videoId;
                let uploadAddress = success.data.uploadAddress;
                uploader.setUploadAuthAndAddress(
                  uploadInfo,
                  uploadAuth,
                  uploadAddress,
                  videoId
                );
              }, (error) => {
                that.$message.error(error.msg);
              }).catch((err) => {
                console.log(err);
                that.$message.error("凭证获取异常！");
              });
            }).catch((err) => {
              console.log(err);
              that.$message.error("凭证获取异常！");
            });
          } else { // 如果 uploadInfo.videoId 不存在,调用 获取视频上传地址和凭证接口
            let params = {
              // 在文件变动的时候这些字段有值
              cid: that.courseInfo.cid,
              title: that.courseInfo.title,
              fileExt: fileExt,
            };
            that.$api.get("/content/upload/video/auth.json", params).then((success) => {
              // 保存结果
              info.authRes = success.data;
              info.videoId = success.data.videoId; // 视频id
              // 设置凭证 从点播服务获取的uploadAuth、uploadAddress和videoId,设置到SDK里
              let uploadAuth = success.data.uploadAuth;
              let videoId = success.data.videoId;
              let uploadAddress = success.data.uploadAddress;
              uploader.setUploadAuthAndAddress(
                uploadInfo,
                uploadAuth,
                uploadAddress,
                videoId
              );
            }, (error) => {
              that.$message.error(error.msg);
            }).catch((err) => {
              console.log(err);
              that.$message.error("凭证获取异常！");
            });
          }
        },
        // 文件上传成功
        onUploadSucceed: function (uploadInfo) {
          // 把文件对象置空  上传对象置空
          info.uploader = null;
          info.file = null;
          // 显示播放按钮
          // that.playFlag = true;
          // that.isCanPlay();
          // 调用接口更新课程的视频
          let param = {
            id: info.contentId,
            videoId: info.videoId,
          };
          let res = that.$api.post("/content/video/update.json", param);
          res.then((success) => {
            // 保存结果
            console.log("保存结果", success, info);
            // that.$message({message: "内容添加成功！", type: "success"});
            // 把状态码修改为 2-上传结束
            that.$set(info, "uploadStatus", 2);
            // 进行下一次文件提交
            that.createCourse();
          }, (error) => {
            that.$message.error(error.msg);
          }).catch((err) => {
            that.$message.error("视频已上传，但绑定内容异常！");
          });
          // console.log("onUploadSucceed: " + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object);
        },
        // 文件上传失败
        onUploadFailed: function (uploadInfo, code, message) {
          console.log("上传失败:" + uploadInfo.file.name + ",code:" + code + ", message:" + message);
          if (uploadInfo.videoId) {
            console.log("上传失败断点续传------------------------------");
            console.log(uploadInfo.videoId);
            // 如果 uploadInfo.videoId 存在, 调用 刷新视频上传凭证接口  GET /1.0/content/upload/video/auth/refresh.json
            that.$api.get("/content/upload/video/auth/refresh.json", { videoId: uploadInfo.videoId }).then((success) => {
              info.authRes = success.data;
              info.videoId = success.data.videoId; // 视频id
              // 设置凭证 从点播服务获取的uploadAuth、uploadAddress和videoId,设置到SDK里
              let uploadAuth = success.data.uploadAuth;
              let uploadAddress = success.data.uploadAddress;
              uploader.setUploadAuthAndAddress(
                uploadInfo,
                uploadAuth,
                uploadAddress
              );
            }, (error) => {
              // that.$message.error(error.msg)
              // 刷新不到凭证就重新获取
              let fileExt = uploadInfo.file.name.split(".");
              fileExt = fileExt[fileExt.length - 1];
              let params = {
                // 在文件变动的时候这些字段有值
                cid: that.courseInfo.cid,
                title: that.courseInfo.title,
                fileExt: fileExt,
              };
              that.$api.get("/content/upload/video/auth.json", params).then((success) => {
                // 保存结果
                info.authRes = success.data;
                info.videoId = success.data.videoId; // 视频id
                //  设置凭证   从点播服务获取的uploadAuth、uploadAddress和videoId,设置到SDK里
                let uploadAuth = success.data.uploadAuth;
                let videoId = success.data.videoId;
                let uploadAddress = success.data.uploadAddress;
                uploader.setUploadAuthAndAddress(
                  uploadInfo,
                  uploadAuth,
                  uploadAddress,
                  videoId
                );
              }, (error) => {
                that.$message.error(error.msg);
              }).catch((err) => {
                console.log(err);
                that.$message.error("凭证获取异常！");
              });
            }).catch((err) => {
              console.log(err);
              that.$message.error("凭证获取异常！");
            });
          }
        },
        // 文件上传进度，单位：字节
        onUploadProgress: function (uploadInfo, totalSize, loadedPercent) {
          let authProgress = Math.ceil(loadedPercent * 100);
          info.progress = authProgress;
        },
        // 上传凭证超时
        onUploadTokenExpired: function (uploadInfo) {
          // 实现时，根据 uploadInfo.videoId 调用刷新视频上传凭证接口重新获取UploadAuth
          let params = { videoId: uploadInfo.videoId };
          let res = that.$api.get("/content/upload/video/auth/refresh.json", params);
          res.then((success) => {
            // 保存结果
            info.authRes = success.data;
            //从点播服务刷新的uploadAuth,设置到SDK里
            let uploadAuth = success.data.uploadAuth;
            uploader.resumeUploadWithAuth(uploadAuth);
          }, (error) => {
            that.$message.error(error.msg);
          }).catch((err) => {
            that.$message.error("凭证获取异常！");
          });
        },
        //全部文件上传结束
        onUploadEnd: function (uploadInfo) {
          console.log("上传完成！");
        },
      });
      return uploader;
    },
    // 开始上传
    uploadStart() {
      console.log("前期准备", this.courseInfo);
      if(!this.videoList.length) {
        return this.$message.error("请先添加视频！");
      }
      const speed = this.videoList.every(o => { return o.speed });
      if(!speed) {
        return this.$message.error("请完善视频的曲速！");
      }
      const videoId = this.videoList.every(o => { return o.file });
      if(!videoId) {
        return this.$message.error("请选择要上传的视频！");
      }
      // 开始上传
      console.log("准备上传", this.videoList);
      this.createCourse();
    },
    // 创建每个曲速对应的子课程
    createCourse() {
      const info = this.videoList.find(o => {return o.uploadStatus === 0});
      console.log("开始上传", info);
      if(!info) { // 没有传递视频信息，或已经全部上传完成
        this.$message.success("上传完成！");
        this.$emit("end");
        return;
      }
      this.$emit("change", true);
      let param = {
        ...this.courseInfo,
        speed: info.speed
      }
      let res = this.$api.post("/content/add.json", param);
      res.then((success) => {
        this.$set(info, "contentId", success.data); // 记录子课程编号
        info.uploader.startUpload(); // 开始提交视频，准备更新
      }, (error) => {
        this.$message.error(error.msg);
      }).catch((err) => {
        this.$message.error("内容生成异常，无法添加视频！");
      });
    }
  },
};
</script>

<style scoped>
.progress {
  margin: 0.5rem 0;
}
</style>



// WEBPACK FOOTER //
// src/components/practiceManage/AddVideos.vue